"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTypes = exports.DialogSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var hooks_1 = require("../../../../hooks");

var __1 = require("../../..");

var Button_1 = tslib_1.__importDefault(require("../../../Buttons/Button"));

var styles = tslib_1.__importStar(require("./Dialog.style"));

exports.DialogSizes = ['400', '500', '700'];
exports.DialogTypes = ['primary', 'secondary', 'gray', 'outline'];
var Dialog = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      onCloseClick = _ref.onCloseClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '400' : _ref$size,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      confirmButtonContent = _ref.confirmButtonContent,
      _ref$confirmButtonTyp = _ref.confirmButtonType,
      confirmButtonType = _ref$confirmButtonTyp === void 0 ? 'primary' : _ref$confirmButtonTyp,
      optionButtonContent = _ref.optionButtonContent,
      _ref$optionButtonType = _ref.optionButtonType,
      optionButtonType = _ref$optionButtonType === void 0 ? 'gray' : _ref$optionButtonType,
      titleText = _ref.titleText,
      titleActionText = _ref.titleActionText,
      onConfirmClick = _ref.onConfirmClick,
      onOptionClick = _ref.onOptionClick,
      onTitleActionClick = _ref.onTitleActionClick,
      additionalTitleText = _ref.additionalTitleText,
      additionalContentText = _ref.additionalContentText,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$optionDisabled = _ref.optionDisabled,
      optionDisabled = _ref$optionDisabled === void 0 ? false : _ref$optionDisabled;
  var contentRef = react_1.useRef(null);
  var hasFooter = additionalTitleText || additionalContentText || optionButtonContent || confirmButtonContent;
  hooks_1.useResetScroll(contentRef);
  hooks_1.useDialogPreventParentScroll(isOpen);

  function handleClosableClick(event) {
    onCloseClick && onCloseClick(event);
    toggle && toggle(false);
  }

  function handleConfirmClick() {
    onConfirmClick && onConfirmClick();
  }

  function handleOptionClick() {
    onOptionClick && onOptionClick();
  }

  function handleTitleActionClick() {
    onTitleActionClick && onTitleActionClick();
  }

  return react_dom_1.createPortal(jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx("div", {
      role: "dialog",
      css: [styles.backdrop, isOpen ? styles.backdropShow : styles.backdropHide],
      onClick: handleClosableClick
    }, void 0), jsx_runtime_1.jsxs("div", Object.assign({
      className: className,
      css: [styles.root(size), isOpen ? styles.dialogShow : styles.dialogHide]
    }, {
      children: [jsx_runtime_1.jsxs("div", Object.assign({
        css: [styles.title, !titleText && styles.noTitle],
        className: "mrt-dialog-title"
      }, {
        children: [titleText && jsx_runtime_1.jsx("span", Object.assign({
          css: styles.titleContent
        }, {
          children: titleText
        }), void 0), jsx_runtime_1.jsxs("span", Object.assign({
          css: styles.titleAction
        }, {
          children: [titleActionText && jsx_runtime_1.jsx("span", Object.assign({
            onClick: handleTitleActionClick,
            css: styles.titleActionText
          }, {
            children: titleActionText
          }), void 0), jsx_runtime_1.jsx(__1.Icon, {
            name: "ic_close_md_gray_500",
            alt: "close",
            onClick: function onClick(event) {
              handleClosableClick(event);
            }
          }, void 0)]
        }), void 0)]
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({
        className: "mrt-dialog-content",
        ref: ref || contentRef,
        css: [styles.content(height), !titleText && styles.noTitleContent]
      }, {
        children: children
      }), void 0), hasFooter && jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.footer
      }, {
        children: [jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.additionalInfo
        }, {
          children: [jsx_runtime_1.jsx("span", Object.assign({
            css: styles.additionalTitle
          }, {
            children: additionalTitleText
          }), void 0), jsx_runtime_1.jsx("span", Object.assign({
            css: styles.additionalContent
          }, {
            children: additionalContentText
          }), void 0)]
        }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.buttonGroup
        }, {
          children: [optionButtonContent && jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: optionButtonType,
            size: "medium",
            onClick: handleOptionClick,
            disabled: optionDisabled
          }, {
            children: optionButtonContent
          }), void 0), confirmButtonContent && jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: confirmButtonType,
            size: "medium",
            onClick: handleConfirmClick,
            disabled: disabled,
            loading: loading
          }, {
            children: confirmButtonContent
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }, void 0), document.body);
});
exports.default = Dialog;